import { newSpecPage } from "@stencil/core/testing";
import { Tile } from "../tile";

describe("uic-tile", () => {
    it("renders", async () => {
        const page = await newSpecPage({
            components: [Tile],
            html: `<uic-tile></uic-tile>`
        });
        expect(page.root).toEqualHtml(`
            <uic-tile>
                <div class="uic-tile uic-tile--clickable uic-tile--light" tabindex="1">
                    <div class="uic-tile__header">
                        <div class="uic-tile__label"></div>
                        <div class="uic-tile__border"></div>
                    </div>
                    <div class="uic-tile__content">
                        <div class="uic-tile__content-container"></div>
                    </div>
                </div>
            </uic-tile>
    `);
    });

    it("renders with content and label", async () => {
        const page = await newSpecPage({
            components: [Tile],
            html: `<uic-tile headline="Header"><p>Example content</p></uic-tile>`
        });
        expect(page.root).toEqualHtml(`
            <uic-tile headline="Header">
                <div class="uic-tile uic-tile--clickable uic-tile--light uic-tile--with-content" tabindex="1">
                    <div class="uic-tile__header">
                        <div class="uic-tile__label">Header</div>
                        <div class="uic-tile__border"></div>
                    </div>
                    <div class="uic-tile__content">
                        <div class="uic-tile__content-container"><p>Example content</p></div>
                    </div>
                </div>
            </uic-tile>
    `);
    });

    it("renders without header", async () => {
        const page = await newSpecPage({
            components: [Tile],
            html: `<uic-tile variant="content-only"><p>Example content</p></uic-tile>`
        });
        expect(page.root).toEqualHtml(`
            <uic-tile variant="content-only">
                <div class="uic-tile uic-tile--clickable uic-tile--content-only uic-tile--with-content" tabindex="1">
                    <div class="uic-tile__content">
                        <div class="uic-tile__content-container"><p>Example content</p></div>
                    </div>
                </div>
            </uic-tile>
    `);
    });
});
